import { Input, InputProps } from "@mantine/core";
import { ChangeEvent, ReactNode } from "react";

import Flex from "components/Flex";
import { WarningIcon } from "components/Icons/Warning";
import Text from "components/Text";
import ErrorMessage from "components/ErrorMessage";

import { useStyles } from "./styles";

type TextInputProps = InputProps<"input"> & {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  warning?: string;
  label?: ReactNode;
  description?: ReactNode;
  name: string;
  value: string;
  error?: string;
};

export const TextInput = ({ onChange, warning, label, description, name, value, error, ...mantineProps }: TextInputProps) => {
  const { classes } = useStyles();

  return (
    <Flex gap={16}>
      <Flex gap={4}>
        <label htmlFor={name}>{label}</label>
        {description}
      </Flex>
      <Flex gap={4}>
        <Input
          {...mantineProps}
          id={name}
          type="text"
          size="md"
          value={value}
          classNames={{ input: classes.input }}
          onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event)}
        />

        {warning && (
          <Flex direction="row" gap={6}>
            <WarningIcon className={classes.warning} alt="Warning" />
            <Text as="div" sizeVariant="md">
              {warning}
            </Text>
          </Flex>
        )}
        {error && (
          <ErrorMessage message={error}></ErrorMessage>
        )}
      </Flex>
    </Flex>
  );
};
